module.exports = __webpack_public_path__ + "static/media/Icn-docx.14b4ff22.svg";